// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__c8K-8","footer":"ModalFilter_footer__3GFKH"};